module.exports = __webpack_public_path__ + "img/x-factor-investigations.549095e5.svg";